var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuporteColorido(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5565 27.5096C30.7546 24.9564 32.0833 21.6334 32.0833 18C32.0833 14.3666 30.7546 11.0436 28.5565 8.4903L22.3254 14.7213C22.9614 15.6557 23.3333 16.7845 23.3333 18C23.3333 19.2155 22.9614 20.3443 22.3254 21.2786L28.5565 27.5096Z",
    fill: "#883C8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0097 29.0565C24.4565 31.2547 21.1335 32.5834 17.5001 32.5834C13.8667 32.5834 10.5436 31.2547 7.99036 29.0565L14.2214 22.8255C15.1558 23.4615 16.2845 23.8334 17.5001 23.8334C18.7156 23.8334 19.8443 23.4615 20.7787 22.8255L27.0097 29.0565Z",
    fill: "#FB4747"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44346 27.5096L12.6745 21.2786C12.0384 20.3443 11.6666 19.2155 11.6666 18C11.6666 16.7845 12.0384 15.6557 12.6745 14.7213L6.44346 8.4903C4.24537 11.0436 2.91663 14.3666 2.91663 18C2.91663 21.6334 4.24537 24.9564 6.44346 27.5096Z",
    fill: "#76B900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 12.1667C16.2845 12.1667 15.1558 12.5385 14.2214 13.1746L7.99036 6.94352C10.5436 4.74543 13.8667 3.41669 17.5001 3.41669C21.1335 3.41669 24.4565 4.74543 27.0097 6.94352L20.7787 13.1746C19.8443 12.5385 18.7156 12.1667 17.5001 12.1667Z",
    fill: "#003F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuporteColorido);
export default __webpack_public_path__ + "static/media/suporte-colorido.344c41cf71cc72347b815c46dff45c10.svg";
export { ForwardRef as ReactComponent };